import Hero from "@/components/Hero";
import ServicesGrid from "@/components/ServicesGrid";
import ProductsTeaser from "@/components/ProductsTeaser";
import HowItWorks from "@/components/HowItWorks";
import TrustSection from "@/components/TrustSection";
import CTASection from "@/components/CTASection";
import TechStack from "@/components/TechStack";
import ClientLogos from "@/components/ClientLogos";
import Testimonials from "@/components/Testimonials";
import AuditBanner from "@/components/AuditBanner";
import SEO, { OrgJsonLd } from "@/components/SEO";

export default function Home() {
  return (
    <>
      <SEO
        title="Enterprise IT Services & Products"
        description="United Techlab builds custom software, scales cloud, modernizes legacy, staffs elite engineering teams, and ships enterprise AI products, all with verification-first rigor."
        path="/"
        jsonLd={OrgJsonLd}
      />
      <Hero />
      <ClientLogos />
      <ServicesGrid compact />
      <TechStack />
      <ProductsTeaser />
      <AuditBanner />
      <HowItWorks />
      <Testimonials />
      <TrustSection />
      <CTASection />
    </>
  );
}
